import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useMediaQuery } from '@mui/material';

const TableDevolve = (props) =>  {
  const isMobile = useMediaQuery('(max-width:768px)');
  const isTablet= useMediaQuery('(max-width:1024px)');
  const minWidth = isMobile ? 50 : isTablet ? 60 : 130;
  const columns = [
    { id: 'id', label: 'Id', minWidth, align: 'center',},
    { id: 'data', label: 'Data', minWidth, align: 'center',},
    { id: 'store', label: 'Loja', minWidth, align: 'center',},
    { id: 'pedido', label: 'Pedido', minWidth, align: 'center',},
    { id: 'saleValue', label: 'Valor', minWidth, align: 'center',},
    { id: 'value', label: 'Cashback', minWidth, align: 'center', format: (value) => value.toLocaleString('en-US'),},
    { id: 'status', label: 'Status', minWidth, align: 'center', format: (value) => value.toLocaleString('en-US'),},
  ];
  
  function createData(id, store, saleValue, value, status, pedido, data) {
    const density = value / status;
    return { id, store, saleValue, value, status, density, pedido, data};
  }
  
  // const rows = [
  //   createData('India', 'IN', 1324171354, 3287263),
  //   createData('China', 'CN', 1403500365, 9596961),
  //   createData('Italy', 'IT', 60483973, 301340),
  //   createData('United States', 'US', 327167434, 9833520),
  //   createData('Canada', 'CA', 37602103, 9984670),
  //   createData('Australia', 'AU', 25475400, 7692024)
  // ];
  const statusMap = {
    PENDING: "Pendente",
    PAID: "Pago",
    CASHBACK: "Aprovado",
    CANCELED: "Cancelado"
  };
  const rows = props.cashbacks.map((cashback) => {
    const statusLabel = statusMap[cashback.status] || cashback.status;
    const pedido = cashback.storeOrderId || cashback.conversion?.externalId;
    const rawDate = cashback.conversion?.conversionTime;
    
    const formattedDate = rawDate
      ? new Intl.DateTimeFormat('pt-BR').format(new Date(rawDate))
      : '';

    return createData(cashback.id, cashback.store.name, cashback.saleValue, cashback.value, statusLabel, pedido, formattedDate);
  });

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden',  maxWidth: '100vw', }}>
      <TableContainer sx={{ maxHeight: 440, overflowX: 'auto' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  sx={{'&.MuiTableCell-head': {
                    backgroundColor: '#2EAF80',
                    fontWeight: 'bold'
                  }, }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
          {rows
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row) => {
            return (
              <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                {columns.map((column) => {
                  const value = row[column.id];

                  // Estilo condicional para o status
                  const getStatusStyle = (status) => {
                    switch (status) {
                      case "Pendente":
                        return { color: "#FFA500", fontWeight: "bold" };
                      case "Aprovado":
                        return { color: "#FFD700", fontWeight: "bold" }; // Amarelo mais escuro
                      case "Cancelado":
                        return { color: "#FF0000", fontWeight: "bold" };
                      case "Pago":
                        return { color: "#008000", fontWeight: "bold" };
                      default:
                        return { fontWeight: "bold" }; // Negrito para valores desconhecidos
                    }
                  };

                  return (
                    <TableCell key={column.id} align={column.align}>
                      {column.id === "status" ? (
                        <span style={getStatusStyle(value)}>{value}</span>
                      ) : column.format && typeof value === "number" ? (
                        column.format(value)
                      ) : (
                        value
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default TableDevolve